function redirectToLoginPage(): void {
  const loginURL = import.meta.env.VITE_LOGIN_URL;
  window.location.replace(loginURL);
}

export { redirectToLoginPage };
